import crown from '../../assets/crown.png';
import { quickStartConfig } from '../../app/quickStart';
import { useApp } from '../store';

export function MainMenu() {
  const setScreen = useApp((s) => s.setScreen);
  const live = useApp((s) => s.liveBuild);
  return (
    <div className="menu-bg">
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div className="title-block">
          <img className="title-crown" src={crown} alt="" />
          <h1 className="game-title">Four Crowns</h1>
          <div className="game-subtitle">A historical real-time strategy</div>
        </div>
        <div className="main-menu">
          <button className="menu-btn" onClick={() => {
            // One click to a game: you against a Standard computer player on a random map.
            useApp.setState({ entry: 'single', pendingConfig: quickStartConfig(useApp.getState().prefs.playerName), screen: 'game', menuOpen: false, launch: null });
          }}>Single Player<span className="menu-sub">Quick game against the computer</span></button>
          <button className="menu-btn" onClick={() => setScreen('multiplayer')}>Multiplayer</button>
          <button className="menu-btn" onClick={() => { useApp.setState({ entry: 'skirmish' }); setScreen('skirmish'); }}>Skirmish<span className="menu-sub">Choose map, civilisations and opponents</span></button>
          <button className="menu-btn" onClick={() => setScreen('load')}>Load Game</button>
          <button className="menu-btn" onClick={() => setScreen('replays')}>Replays</button>
          <button className="menu-btn" onClick={() => setScreen('settings')}>Settings</button>
          <button className="menu-btn" onClick={() => setScreen('credits')}>Credits</button>
        </div>
      </div>
      {live > __APP_BUILD__ ? (
        <button className="update-btn" onClick={() => window.location.reload()} title={`${__APP_VERSION__} is running; build ${String(live).padStart(3, '0')} is live. Click to reload and update.`}>
          Update Available
        </button>
      ) : (
        <div className="version-label">{__APP_VERSION__}</div>
      )}
    </div>
  );
}
